import React, { Component } from 'react'
import { Button } from '@progress/kendo-react-buttons'
import Detalhes from './Detalhes'
import History from './History'
import DadosEntidade from './DadosEntidade'
import Destruction from './Destruction'
import RotuloLink from './RotuloLink'
import services from '../../../../services'


class GraphicasTabMain extends Component {
    constructor(props){
        super(props)
        this.state = {
            tab : 'detalhes',
            tabDetail: '',
            entityDetail: {
                telephone: '',
                email: '',
                fax: ''
            },
            dadosDetail: {},
            rotuloRes: {},
            rotulosToggle: false,
            estatutosRes:[],
        }
    }

    componentDidMount() {
        console.log("did mount worked")
        this.firstTime()
    }

    firstTime = () => {
        this.getDadosEntidadeDeatils()
        this.rotuloLinkDeatail()
        this.estatutosApi();
    }

    componentDidUpdate(prevProps,prevState) {
        if(prevProps.date!==this.props.date){
            this.firstTime()
            this.updateTab('detalhes')
            console.log("did update worked")
        }
    }

    getEntityDetails = async (entity_id) => {
        try {
            let Request = {};
            Request.entityId = parseInt(entity_id);
            let link = "/Revenue/GetEntityDetail";
            let entityDetail={}
            let entityDetailResponse = await services.apiCall.requestApi(link, Request);
            if (entityDetailResponse) {
                console.log("the entity detaillllllll", entityDetailResponse)
                entityDetailResponse['v_CC_Entidade_Contact'].map(el => {
                    switch (el.codTipoContacto2) {
                        case "TLM":
                            entityDetail.telephone = el.contacto
                            break;
                        
                        case "EMAIL":
                            entityDetail.email = el.contacto
                            break;
                    
                        default:
                            break;
                    }
                    // if(el.codTipoContacto2 === "TLM"){
                    //     entityDetail.telephone = el.contacto
                    // }
                    // else if(el.codTipoContacto2 === "EMAIL") {
                    //     entityDetail.email = el.contacto
                    // }
                })
                
                this.setState({
                    entityDetail
                })
                console.log("usefullllll responseeeee ", this.state.entityDetail)
            }
        } catch (error) {
            this.setState({error})
        }
    }
    
    getDadosEntidadeDeatils = () => {
        let data = {}
        let link = "Sales/GetDadosEntidadeDetail"
        let dadosDetail 
        let date = new Date(this.props.row['dataCriado'])
        console.log("the date ", date)
        data["entityId"] = this.props.row['idEntidadeAplicacao']
        data["year"] = date.getFullYear()
        console.log("the data I am sending is ", data)
        services.apiCall.requestApi(link, data, "post")
            .then(res => {
                console.log("response is.... ", res)
                dadosDetail = res
                this.setState({
                    dadosDetail
                })
            })
            .catch(error => {
                console.log(error)
            })
    }

    rotuloLinkDeatail = () => {
        let link = "Sales/GetRotuloLinkDetailById"
        let data = {}
        data["idRotulo"] = this.props.row['idRotulo'] ? this.props.row['idRotulo'] : null
        services.apiCall.requestApi(link, data, "post")
            .then(res => {
                console.log("the rotulo response is... ", res)
                this.setState({
                    rotuloRes: res
                }, () => {
                    this.getEntityDetails(this.props.row['idEntidadeAplicacao'])
                    this.showTabDetails(this.state.tab)
                })
            })
            .catch(error => {
                console.log("error is... ", error)
                this.showTabDetails(this.state.tab)
            })
            
       
    }
    estatutosApi= async ()=>{
        let Request = this.filterResponse();
        let link = "Sales/GetEstatutoListByEntityId"
        let estatutosRes = await services.apiCall.requestApi(link,Request);

        this.setState({
            estatutosRes,
        })
       
    }

    filterResponse=()=>{
        let Request={
            "Filters": null,
            "SortBy": "",
            "IsSortTypeDESC": true,
            "IsPagination": true,
            "Page": 1,
            "PageSize": 10,
        }
        let {idEntidadeAplicacao} = this.props.row;
        Request["entityId"]=idEntidadeAplicacao;

        return Request;
    }

    setData = (data) => {
        let newData = {...data}
        this.setState({
            data:{...this.state.data, ...newData}
        })
    }

    updateTab = (tab) => {
        this.setState({
            tab
        }, () => {
            this.showTabDetails(this.state.tab)
        })
    }
    activateLink = () => {
        this.setState(prevState => {
            return {
                rotulosToggle: !prevState.rotulosToggle
            }
        },() => {
            let tabDetail
            if(this.state.rotulosToggle) {
                tabDetail = (
                    <RotuloLink rotuloRes = {this.state.rotuloRes} activateLink={() => this.activateLink()} nPedido={this.props.row['idEntidadeAplicacao']} tipo={this.props.row['tipoSelo']}/>
                )
                this.setState({
                    tabDetail
                })
            }
            else {
                this.updateTab("detalhes")
            }
        })
    }

    showTabDetails = (tab) => {
        let tabDetail = ''
        if(tab === 'detalhes') {
            console.log("the detalhes tab loaded")
            // if(Object.keys(this.state.rotuloRes).length > 0)
                tabDetail = (
                    <Detalhes row={this.props.row} entityDetail={this.state.entityDetail} activateLink={this.activateLink} rotuloRes={this.state.rotuloRes}/>
                )
            // else tabDetail = (
            //     <h1>no way</h1>
            // )
        }
        else if(tab === 'dadosEntidade') {
            tabDetail = (
               <DadosEntidade row={this.props.row} entityDetail={this.state.entityDetail} dadosDetail={this.state.dadosDetail} estatutosRes={this.state.estatutosRes}/>

            )
        }
        else if(tab === 'history') {
            tabDetail = (
                <History row={this.props.row}/>
                // // //<Destruction />
                
            )
        }
        this.setState({
            tabDetail
        })
    }
    render() {
        return (
            <div className="modal-content">
                <div className="modal-header">
                    <span className="modal-title bold" style={{fontSize:"large"}}>
                        <b>Detalhe do pedido</b>
                    </span>
                    <div className="buttons">
                        <Button className="mr-2 k-primary btn-ivdp-secondary btn-theme remove ml-2 text-danger" data-dismiss="modal">Fechar</Button>
                    </div>
                    
                </div>
                <div className="modal-body">

                    {/** tab heading *****************************/}

                <div className="right-tab">
                    <ul className="nav nav-tabs d-flex text-center">
                        <li className="nav-item flex-fill">
                            <strong><a className={`nav-link selos-nav ${this.state.tab === 'detalhes' ? "active" : ""}`}  onClick={() => this.updateTab('detalhes')} data-toggle="tab" href="#Detalhes">Detalhes</a></strong>
                        </li>
                        <li className="nav-item flex-fill">
                            <strong><a className={`nav-link selos-nav ${this.state.tab === 'dadosEntidade' ? "active" : ""}`}  onClick={() => this.updateTab('dadosEntidade')} data-toggle="tab" href="#Dados entidade">Dados entidade</a></strong>
                        </li>
                        <li className="nav-item flex-fill">
                            <strong><a className={`nav-link selos-nav ${this.state.tab === 'history' ? "active" : ""}`}  onClick={() => this.updateTab('history')} data-toggle="tab" href="#Histórico">Histórico</a></strong>
                        </li>
                    </ul>
                        
                        
                        {/* details as per tab**********************/}
                </div>
                    {this.state.tabDetail}
                </div>
            </div>
        )
    }
}

export default GraphicasTabMain